import { render, staticRenderFns } from "./CompanyAdminPanelBody.vue?vue&type=template&id=7bdafa27&scoped=true"
import script from "./CompanyAdminPanelBody.vue?vue&type=script&lang=js"
export * from "./CompanyAdminPanelBody.vue?vue&type=script&lang=js"
import style0 from "./CompanyAdminPanelBody.vue?vue&type=style&index=0&id=7bdafa27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdafa27",
  null
  
)

export default component.exports